import React from 'react';
import { Table, Button } from 'antd';
import { Link } from 'react-router-dom';
import { buildAPBillingConfigPricingModelURI } from 'utils/routes';
import { constructColumn, constructColumnFilterSearch } from 'utils/table/table';
import { capitalizeFirstLetter } from 'utils/general';

const TableComponent = ({ data, countries, loading, duplicateModal }) => {
  console.log(data);
  const columns = [
    {
      ...constructColumn('Model Name', 'name', { hasSorter: true }),
      ...constructColumnFilterSearch('name', 'Search Model Name'),
      render: (text, record) => (
        <Link to={`${buildAPBillingConfigPricingModelURI()}/${record._id}/edit`}>
          <Button type="link">{text}</Button>
        </Link>
      )
    },
    {
      ...constructColumn('Country', 'countryName'),
      ...constructColumnFilterSearch('countryName', 'Search Country')
    },
    {
      title: 'Currency',
      dataIndex: 'currency',
      key: 'currency'
    },
    {
      title: 'Subscription Type',
      dataIndex: 'subscriptionType',
      key: 'subscriptionType',
      render: (text, record) => {
        return <span>{capitalizeFirstLetter(record.subscriptionType)}</span>;
      }
    },
    {
      title: '# of Host',
      dataIndex: 'host',
      key: 'host',
      sorter: (a, b) => (a.host.length || 0) - (b.host.length || 0),
      render: (text, record) => {
        console.log(record); // Log the record to the console
        return <span>{record.host.length > 0 ? record.host.length : 0}</span>;
      }
    },
    {
      title: 'Created At',
      dataIndex: 'createdAtWithFormat',
      key: 'createdAtWithFormat',
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt) // Sort by the original date field
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => <Button onClick={() => duplicateModal(record)}>Duplicate</Button>
    }
  ];
  return (
    <>
      <Table dataSource={data} columns={columns} loading={loading} />
    </>
  );
};

export default TableComponent;
